'use client';

import React from 'react';
import BankAccountDetailsContent from '@/app/dashboard/withdraw/bank-accounts/components/bank-account-details-content';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { setBankAccountDetails } from '@/store/reducers/drawer-content-slice';
import { getUi, hideDrawerState } from '@/store/reducers/ui-slice';

import { GeneralDrawer } from '@/types/general';

import DrawerTemplate from '../core/drawer-template';

export default function BankAccountDetailsDrawer(): React.JSX.Element | null {
  const { drawerState } = useAppSelector(getUi);

  const dispatch = useAppDispatch();

  return (
    <DrawerTemplate
      open={drawerState.BANK_ACCOUNT}
      onClose={() => {
        dispatch(hideDrawerState(GeneralDrawer.BANK_ACCOUNT));
        dispatch(setBankAccountDetails(null));
      }}
      title="Account Details"
      width="830px"
    >
      <BankAccountDetailsContent />
    </DrawerTemplate>
  );
}
